
import { defineComponent } from "vue";
import ScheduleInterface from "@/interfaces/Schedule.interface";
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { clientServices } from "./clientServices.service";
import DialogOptions from "./custom/DialogOptions.vue";
import Dialog from "primevue/dialog";
import dayjs from "dayjs";
import moment from "moment";
import { Qalendar } from "qalendar";
import { ToastFactory } from "@/utils/ToastFactory";
const clientService = new clientServices();

export default defineComponent({
  name: "AddScheduleClient",
  components: { DialogOptions, Qalendar, Dialog },
  data() {
    return {
      isLoadingAvailability: true,
      availableComputersEvents: [] as any[],
      calendarMode: "week" as "day" | "week" | "month",
      selectedCalendarDate: new Date(),
      calendarKey: 0,
      showAvailabilityDialog: false,
      selectedAvailability: null as any,
      scheduleId: "" as string,
      schedule: {
        calendarList: [
          {
            checkIn: "",
            checkOut: "",
            daysWeek: [],
          },
        ] as any,
        recurrence: false,
      } as ScheduleInterface,
      disabled: false,
      selectedDays: [] as any,
      noDaysSelected: false,
      currentBalance: 20,
      confirmGroup: "",
      scheduleInfoDialog: {} as any,
      params: { name: "", page: 0, size: 100 },
      navigator: window.navigator.language,
      weekDays: [
        { name: "domingo", label: "D", enLabel: "Su", value: 0 },
        { name: "segunda", label: "S", enLabel: "M", value: 1 },
        { name: "terça", label: "T", enLabel: "T", value: 2 },
        { name: "quarta", label: "Q", enLabel: "W", value: 3 },
        { name: "quinta", label: "Q", enLabel: "T", value: 4 },
        { name: "sexta", label: "S", enLabel: "F", value: 5 },
        { name: "sabado", label: "S", enLabel: "Sa", value: 6 },
      ],
    };
  },

  setup() {
    return { v$: useVuelidate() };
  },

  computed: {
    calendarConfig(): any {
      return {
        locale: navigator.language,
        defaultMode: this.calendarMode,
        isSilent: false,
        showCurrentTime: true,
        eventDialog: { isDisabled: true },
        week: { startsOn: "sunday" },
        dayBoundaries: { start: 0, end: 24 },
        style: {
          FontFamily: "Inter",
          colorSchemes: {
            available: {
              color: "#155724",
              backgroundColor: "#d4edda",
              borderLeft: "4px solid #28a745",
            },
            full: {
              color: "#721c24",
              backgroundColor: "#f8d7da",
              borderLeft: "4px solid #dc3545",
            },
          },
        },
      };
    },
  },

  watch: {
    "schedule.initDate"() {
      this.applyDateFilter();
    },
    "schedule.finishDate"() {
      this.applyDateFilter();
    },
  },

  validations() {
    return {
      schedule: {
        calendarList: [
          {
            checkIn: { required },
            checkOut: { required },
          },
        ],
        initDate: { required },
      },
    };
  },

  methods: {
    openAvailabilityDialog(event: any): void {
      this.selectedAvailability = event.clickedEvent;
      this.showAvailabilityDialog = true;
    },

    formatAvailabilityTime(value: string): string {
      if (!value) return "";
      const time = dayjs(value);
      if (!time.isValid()) return "";
      return time.format("HH:mm");
    },

    formatAvailabilityDate(value: string): string {
      if (!value) return "";
      const date = dayjs(value);
      if (!date.isValid()) return "";
      return date.format("DD/MM/YYYY");
    },

    getToggleValue(value: boolean) {
      this.schedule.recurrence = value;
      if (!value) {
        this.schedule.finishDate = "";
        this.selectedDays = [];
      }
    },

    onSelectDays(selectedDays: any) {
      this.selectedDays = selectedDays;
    },

    getBalanceUser() {
      clientService.getBalanceUser().then((response: any) => {
        this.currentBalance = response.currentCredit;
      });
    },
    applyDateFilter() {
      if (!this.schedule.initDate) {
        this.calendarMode = "week";
        this.selectedCalendarDate = new Date();
        this.fetchComputerAvailability();
        return;
      }

      const start = dayjs(this.schedule.initDate);
      if (!start.isValid()) return;

      const end = this.schedule.finishDate
        ? dayjs(this.schedule.finishDate)
        : null;

      this.selectedCalendarDate = start.toDate();

      const startStr = start.format("YYYY-MM-DD");
      let endStr = startStr;

      if (!end || !end.isValid() || end.diff(start, "day") <= 0) {
        this.calendarMode = "day";
      } else {
        const diffDays = end.diff(start, "day");
        this.calendarMode = diffDays <= 7 ? "week" : "month";
        endStr = end.format("YYYY-MM-DD");
      }

      this.fetchComputerAvailability(startStr, endStr);
    },
    fetchComputerAvailability(customStart?: string, customEnd?: string) {
      this.isLoadingAvailability = true;
      const startDate =
        customStart || dayjs().startOf("week").format("YYYY-MM-DD");
      const endDate = customEnd || dayjs().endOf("week").format("YYYY-MM-DD");

      clientService
        .getAvailableComputers({ startDate, endDate })
        .then((response: any) => {
          const events: any[] = [];

          response.forEach((item: any, index: number) => {
            const startTime = item.init.slice(0, 5);
            const endTime = item.finish.slice(0, 5);
            const count = item.computersAvailable;
            const label =
              count === 1
                ? this.$t("schedule.availability.macSingular")
                : this.$t("schedule.availability.macPlural");

            events.push({
              id: `avail-${index}-${item.day}`,
              title: `${count} ${label}`,
              macCount: count,
              macLabel: label,
              time: {
                start: `${item.day} ${startTime}`,
                end: `${item.day} ${endTime}`,
              },
              isCustom: true,
              disableDnD: ["month", "week", "day"],
              isEditable: false,
              colorScheme: count > 0 ? "available" : "full",
              description: this.$t("schedule.availability.description"),
            });
          });

          this.availableComputersEvents = events;
          this.calendarKey++;
        })
        .catch((error: any) => {
          this.$toast.add(
            ToastFactory.error(this.$t("schedule.availability.errorLoad")),
          );
        })
        .finally(() => {
          this.isLoadingAvailability = false;
        });
    },

    async getScheduleById() {
      await clientService
        .getScheduleUserById(this.scheduleId)
        .then((response: any) => {
          this.schedule = response;
          this.schedule.recurrence = response.recurrence;
          this.schedule.initDate = dayjs(this.schedule.initDate).format(
            "DD/MM/YYYY",
          );
          this.schedule.finishDate = dayjs(this.schedule.finishDate).format(
            "DD/MM/YYYY",
          );
          this.schedule.calendarList[0].daysWeek.forEach((day: any) => {
            this.selectedDays.push(day.day);
          });
        });
    },

    confirmSchedule() {
      if (this.currentBalance == 0) {
        this.$confirm.require({
          group: "confirmNoCredits",
          header: this.$t("client.noCredits"),
          accept: () => {
            this.$router.push("/comprar-horas");
          },
        });
      } else {
        this.scheduleInfoDialog = {
          initDate: dayjs(this.schedule.initDate).format("DD/MM/YYYY"),
          finishDate: dayjs(this.schedule.finishDate).format("DD/MM/YYYY"),
          weekDays: this.selectedDays,
          checkIn: moment(this.schedule.calendarList[0].checkIn).format(
            "HH:mm",
          ),
          checkOut: moment(this.schedule.calendarList[0].checkOut).format(
            "HH:mm",
          ),
        } as any;
        this.schedule.recurrence
          ? (this.confirmGroup = "confirmRecurrent")
          : (this.confirmGroup = "confirmUnique");
        this.$confirm.require({
          header: this.$t("client.confirmSchedule"),
          message: this.$t("client.confirmInfo"),
          accept: () => {
            this.saveSchedule();
          },
        });
      }
    },

    saveSchedule() {
      let scheduleConvert = {};

      if (this.schedule.recurrence) {
        scheduleConvert = {
          initDate: dayjs(this.schedule.initDate).format("YYYY-MM-DD"),
          finishDate: dayjs(this.schedule.finishDate).format("YYYY-MM-DD"),
          recurrence: this.schedule.recurrence,
          calendarList: [
            {
              checkIn: moment(this.schedule.calendarList[0].checkIn).format(
                "HH:mm:00",
              ),
              checkOut: moment(this.schedule.calendarList[0].checkOut).format(
                "HH:mm:00",
              ),
              daysWeek: this.selectedDays,
            },
          ],
        } as ScheduleInterface;
      } else {
        scheduleConvert = {
          initDate: dayjs(this.schedule.initDate).format("YYYY-MM-DD"),
          recurrence: this.schedule.recurrence,
          calendarList: [
            {
              checkIn: moment(this.schedule.calendarList[0].checkIn).format(
                "HH:mm:00",
              ),
              checkOut: moment(this.schedule.calendarList[0].checkOut).format(
                "HH:mm:00",
              ),
            },
          ],
        } as ScheduleInterface;
      }

      clientService
        .createSchedule(scheduleConvert)
        .then((response: any) => {
          this.$router.push("/agendamento");
          this.$toast.add(
            ToastFactory.success(this.$t("toast.sucessSchedule")),
          );
        })
        .catch(async (error) => {
          this.$toast.add(
            ToastFactory.error(this.codeError(error.response.data.code)),
          );
          console.log(error.response.data.code);
        });
    },

    codeError(error: string): string {
      switch (error) {
        case "HOUR_ERROR":
          return this.$t("errors.hourError");
        case "ERROR_AMOUNT_BALANCE":
          return this.$t("errors.errorAmountBalance");
        case "COMPUTER_AMOUNT":
          return this.$t("errors.computerAmount");
        case "BETWEEN_HOUR_ERROR":
          return this.$t("errors.betweenHourError");
        default:
          return this.$t("errors.defaultError");
      }
    },

    async sendShedule(): Promise<void> {
      this.v$.schedule.$touch();
      if (this.v$.schedule.$error) return;

      if (!this.scheduleId && !this.isValidHourRange()) return;

      this.scheduleId
        ? this.$router.push("/agendamento")
        : this.confirmSchedule();
    },

    isValidHourRange(): boolean {
      const checkIn = this.schedule.calendarList[0].checkIn as any;
      const checkOut = this.schedule.calendarList[0].checkOut as any;
      const inDate = checkIn instanceof Date ? checkIn : new Date(checkIn);
      const outDate = checkOut instanceof Date ? checkOut : new Date(checkOut);
      if (isNaN(inDate.getTime()) || isNaN(outDate.getTime())) {
        return false;
      }
      const inMinutes = inDate.getHours() * 60 + inDate.getMinutes();
      const outMinutes = outDate.getHours() * 60 + outDate.getMinutes();
      if (outMinutes <= inMinutes) {
        this.$toast.add(ToastFactory.error(this.$t("errors.hourError")));
        return false;
      }
      if ((outMinutes - inMinutes) % 60 !== 0) {
        this.$toast.add(
          ToastFactory.error(this.$t("errors.betweenHourError"))
        );
        return false;
      }
      return true;
    },
  },

  mounted() {
    this.scheduleId = this.$route.params.id as string;
    this.scheduleId ? this.getScheduleById() : undefined;
    this.fetchComputerAvailability();
  },
});
